import { createContext } from '@lit/context';
import { RealtimeConnection } from '../realtime/realtime-connection';

// The single RealtimeConnection instance the app shares. `undefined` until
// app-index has constructed it (which it does eagerly in firstUpdated).
// Pages that want to subscribe to events should use WithRealtimeConsumer
// and then `realtime?.on('eventName', handler)`.
export const RealtimeContext = createContext<RealtimeConnection | undefined>(
  'realtime-connection'
);
